import { createContext, useContext, useState } from "react";

const LangCtx = createContext({ lang: "en", setLang: () => {} });

export const LangProvider = ({ children }) => {
    const [lang, setLangState] = useState(localStorage.getItem("ds_lang") || "en");
    const setLang = (l) => {
        localStorage.setItem("ds_lang", l);
        setLangState(l);
    };
    return <LangCtx.Provider value={{ lang, setLang }}>{children}</LangCtx.Provider>;
};

export const useLang = () => useContext(LangCtx);

const HI = {
    "Packages": "पैकेज",
    "Stay & Food": "रहना व भोजन",
    "Payment": "भुगतान",
    "Book Now": "अभी बुक करें",
    "Gaya · Bihar": "गया · बिहार",
    "Sacred Rituals · Gaya, Bihar": "पवित्र अनुष्ठान · गया, बिहार",
    "Authentic Pinddaan,": "प्रामाणिक पिंडदान,",
    "Shradh & Tarpan": "श्राद्ध एवं तर्पण",
    "at the Holy Vedis of Gaya": "गया की पवित्र वेदियों पर",
    "Complete rituals performed by traditional Gayawal Pandas at Vishnupad Temple, Falgu River, Akshayavat and the sacred vedis of Gaya — with transparent 40% advance booking.":
        "परंपरागत गयावाल पांडों द्वारा विष्णुपद मंदिर, फल्गु नदी, अक्षयवट और गया की पवित्र वेदियों पर संपूर्ण अनुष्ठान — पारदर्शी 40% एडवांस बुकिंग के साथ।",
    "View Packages": "पैकेज देखें",
    "Chat on WhatsApp": "व्हाट्सएप पर बात करें",
    "Chapter 01 — Our Rituals": "अध्याय ०१ — हमारे अनुष्ठान",
    "Ritual Packages": "अनुष्ठान पैकेज",
    "Prices below are for complete authentic rituals only. Accommodation & fooding are NOT included — assistance is available separately on request.":
        "नीचे दिए गए मूल्य केवल संपूर्ण प्रामाणिक अनुष्ठानों के लिए हैं। रहना और भोजन शामिल नहीं है — अनुरोध पर अलग से सहायता उपलब्ध है।",
    "Complete Rituals": "संपूर्ण अनुष्ठान",
    "Complete Pinddaan & Shradh Ritual Packages": "संपूर्ण पिंडदान एवं श्राद्ध अनुष्ठान पैकेज",
    "Full multi-day ritual programmes at the sacred vedis of Gaya, performed by traditional Gayawal Pandas.":
        "परंपरागत गयावाल पांडों द्वारा गया की पवित्र वेदियों पर संपूर्ण बहु-दिवसीय अनुष्ठान कार्यक्रम।",
    "Special Rituals": "विशेष अनुष्ठान",
    "Special Ritual Packages": "विशेष अनुष्ठान पैकेज",
    "Focused single-day rituals for specific ancestral needs — Tripindi Shradh, Narayan Bali, Nag Bali and Pitru Dosha Nivaran.":
        "विशिष्ट पैतृक आवश्यकताओं हेतु एक-दिवसीय अनुष्ठान — त्रिपिंडी श्राद्ध, नारायण बलि, नाग बलि और पितृ दोष निवारण।",
    "Ritual": "अनुष्ठान",
    "1 Day": "1 दिन",
    "3 Days": "3 दिन",
    "5 Days": "5 दिन",
    "7 Days": "7 दिन",
    "17 Days": "17 दिन",
    "Total Price": "कुल मूल्य",
    "40% Advance": "40% एडवांस",
    "60% On Arrival": "60% आगमन पर",
    "View Details": "विवरण देखें",
    "Book This Ritual": "यह अनुष्ठान बुक करें",
    "more": "और",
    "Price is for the complete ritual only. Accommodation & fooding are NOT included and can be arranged separately on request.":
        "मूल्य केवल संपूर्ण अनुष्ठान के लिए है। रहना और भोजन शामिल नहीं है और अनुरोध पर अलग से व्यवस्था की जा सकती है।",
    "1 Day Complete Pinddaan & Shradh Rituals": "1 दिवसीय संपूर्ण पिंडदान एवं श्राद्ध अनुष्ठान",
    "3 Day Complete Pinddaan & Shradh Rituals": "3 दिवसीय संपूर्ण पिंडदान एवं श्राद्ध अनुष्ठान",
    "5 Day Complete Pinddaan & Shradh Rituals": "5 दिवसीय संपूर्ण पिंडदान एवं श्राद्ध अनुष्ठान",
    "7 Day Complete Pinddaan & Shradh Rituals": "7 दिवसीय संपूर्ण पिंडदान एवं श्राद्ध अनुष्ठान",
    "17 Day Complete Pinddaan & Shradh Rituals": "17 दिवसीय संपूर्ण पिंडदान एवं श्राद्ध अनुष्ठान",
    "Tripindi Shradh": "त्रिपिंडी श्राद्ध",
    "Narayan Bali with Pinddaan": "नारायण बलि सहित पिंडदान",
    "Nag Bali with Pinddaan": "नाग बलि सहित पिंडदान",
    "Pitru Dosha Nivaran Puja": "पितृ दोष निवारण पूजा",
    "Most Popular": "सबसे लोकप्रिय",
    "Comprehensive Tarpan": "विस्तृत तर्पण",
    "Full Ancestral Moksha": "संपूर्ण पितृ मोक्ष",
    "Extended Shradh": "विस्तारित श्राद्ध",
    "Complete Sapindi Karan": "संपूर्ण सपिंडीकरण",
    "Special Ritual": "विशेष अनुष्ठान",
    "Complete authentic 1-day Pinddaan & Shradh rituals performed by traditional Gayawal Pandas at the sacred vedis of Gaya.":
        "परंपरागत गयावाल पांडों द्वारा गया की पवित्र वेदियों पर संपूर्ण प्रामाणिक 1-दिवसीय पिंडदान एवं श्राद्ध अनुष्ठान।",
    "3-day authentic ritual covering multiple sacred vedis in Gaya, performed by qualified Gayawal Pandas.":
        "योग्य गयावाल पांडों द्वारा गया की अनेक पवित्र वेदियों को सम्मिलित करता 3-दिवसीय प्रामाणिक अनुष्ठान।",
    "5-day comprehensive Pinddaan & Shradh rituals at all applicable sacred vedis in Gaya.":
        "गया की समस्त पवित्र वेदियों पर 5-दिवसीय व्यापक पिंडदान एवं श्राद्ध अनुष्ठान।",
    "7-day extended Pinddaan & Shradh rituals with detailed tarpan at the sacred vedis of Gaya by traditional Gayawal Pandas.":
        "परंपरागत गयावाल पांडों द्वारा गया की पवित्र वेदियों पर विस्तृत तर्पण सहित 7-दिवसीय पिंडदान एवं श्राद्ध अनुष्ठान।",
    "The complete 17-day traditional Gaya Shradh covering every applicable sacred vedi, the most comprehensive ancestral ritual.":
        "संपूर्ण 17-दिवसीय परंपरागत गया श्राद्ध जिसमें प्रत्येक पवित्र वेदि सम्मिलित है — सबसे व्यापक पैतृक अनुष्ठान।",
    "Tripindi Shradh for ancestors whose rituals were missed or left incomplete, performed at the sacred vedis of Gaya.":
        "त्रिपिंडी श्राद्ध उन पूर्वजों के लिए जिनके अनुष्ठान छूट गए या अधूरे रह गए, गया की पवित्र वेदियों पर संपन्न।",
    "Narayan Bali ritual with Pinddaan for ancestors who attained unnatural death, performed as per vedic tradition.":
        "अस्वाभाविक मृत्यु प्राप्त पूर्वजों हेतु वैदिक परंपरा अनुसार नारायण बलि सहित पिंडदान।",
    "Nag Bali ritual with Pinddaan for removal of sarpa dosha and peace of departed souls, performed by Gayawal Pandas.":
        "सर्प दोष निवारण एवं दिवंगत आत्माओं की शांति हेतु गयावाल पांडों द्वारा नाग बलि सहित पिंडदान।",
    "Pitru Dosha Nivaran Puja to pacify ancestral doshas in the family, performed at the sacred vedis of Gaya.":
        "परिवार में पैतृक दोषों की शांति हेतु पितृ दोष निवारण पूजा, गया की पवित्र वेदियों पर संपन्न।",
    "Traditional Gayawal Pandas": "परंपरागत गयावाल पांडे",
    "Rituals performed by certified Gayawal Pandas following authentic vedic tradition.":
        "प्रामाणिक वैदिक परंपरा का पालन करने वाले प्रमाणित गयावाल पांडों द्वारा अनुष्ठान।",
    "All Sacred Vedis": "समस्त पवित्र वेदियाँ",
    "Falgu River, Vishnupad Temple, Akshayavat, Pretshila and other applicable sacred vedis.":
        "फल्गु नदी, विष्णुपद मंदिर, अक्षयवट, प्रेतशिला और अन्य पवित्र वेदियाँ।",
    "Transparent Pricing": "पारदर्शी मूल्य",
    "40% advance to confirm your booking, 60% payable on arrival. No hidden charges.":
        "बुकिंग की पुष्टि हेतु 40% एडवांस, 60% आगमन पर देय। कोई छिपा शुल्क नहीं।",
    "Chapter 02 — Optional Assistance": "अध्याय ०२ — वैकल्पिक सहायता",
    "Accommodation & Fooding": "आवास एवं भोजन व्यवस्था",
    "Dharm Sarovar Private Limited assists with stay and food arrangements based on your requirements, duration and availability. Charged separately from ritual packages.":
        "धर्म सरोवर प्राइवेट लिमिटेड आपकी आवश्यकता, अवधि और उपलब्धता के अनुसार रहने और भोजन की व्यवस्था में सहायता करता है। अनुष्ठान पैकेज से अलग शुल्क लागू।",
    "AC / Non-AC hotel & dharamshala booking in Gaya and Bodh Gaya": "गया और बोधगया में एसी / नॉन-एसी होटल व धर्मशाला बुकिंग",
    "Pure satvik meals arranged for the family during rituals": "अनुष्ठान के दौरान परिवार हेतु शुद्ध सात्विक भोजन की व्यवस्था",
    "Station & airport pick-up and local family transit": "स्टेशन व एयरपोर्ट पिक-अप तथा स्थानीय पारिवारिक यातायात",
    "Arrangements based on your duration, budget and availability": "आपकी अवधि, बजट और उपलब्धता के अनुसार व्यवस्था",
    "Request Assistance": "सहायता हेतु अनुरोध करें",
    "Chapter 03 — Advance Payment": "अध्याय ०३ — एडवांस भुगतान",
    "Pay 40% Advance to Confirm": "पुष्टि हेतु 40% एडवांस दें",
    "No online payment gateway — simply scan the official UPI QR or transfer to our bank account, then mention the transaction reference in your booking.":
        "कोई ऑनलाइन पेमेंट गेटवे नहीं — बस आधिकारिक UPI QR स्कैन करें या हमारे बैंक खाते में ट्रांसफर करें, फिर बुकिंग में ट्रांज़ैक्शन रेफरेंस दर्ज करें।",
    "Selected Package": "चयनित पैकेज",
    "Total": "कुल",
    "Advance": "एडवांस",
    "Balance": "शेष",
    "Scan & Pay with any UPI App": "किसी भी UPI ऐप से स्कैन कर भुगतान करें",
    "Bank Transfer (NEFT / IMPS / RTGS)": "बैंक ट्रांसफर (NEFT / IMPS / RTGS)",
    "Account Name": "खाता नाम",
    "Bank": "बैंक",
    "Account Number": "खाता संख्या",
    "IFSC Code": "IFSC कोड",
    "Select your ritual package.": "अपना अनुष्ठान पैकेज चुनें।",
    "Pay the 40% advance using the UPI QR code or bank transfer below.": "नीचे दिए UPI QR कोड या बैंक ट्रांसफर से 40% एडवांस दें।",
    "Enter the UPI transaction reference number in the booking form.": "बुकिंग फॉर्म में UPI ट्रांज़ैक्शन रेफरेंस नंबर दर्ज करें।",
    "Submit your booking request.": "अपना बुकिंग अनुरोध जमा करें।",
    "Our team will verify the payment and confirm your booking.": "हमारी टीम भुगतान सत्यापित कर आपकी बुकिंग की पुष्टि करेगी।",
    "Booking confirmation is subject to payment verification by Dharm Sarovar Private Limited.":
        "बुकिंग की पुष्टि धर्म सरोवर प्राइवेट लिमिटेड द्वारा भुगतान सत्यापन के अधीन है।",
    "Share Payment Screenshot": "भुगतान स्क्रीनशॉट साझा करें",
    "Chapter 04 — Reserve Your Date": "अध्याय ०४ — अपनी तिथि आरक्षित करें",
    "Book Your Ritual": "अपना अनुष्ठान बुक करें",
    "Select Package *": "पैकेज चुनें *",
    "Customer Full Name *": "ग्राहक का पूरा नाम *",
    "Mobile Number *": "मोबाइल नंबर *",
    "Email Address": "ईमेल पता",
    "Preferred Ritual Date *": "पसंदीदा अनुष्ठान तिथि *",
    "Number of Family Members": "परिवार के सदस्यों की संख्या",
    "Payment Option *": "भुगतान विकल्प *",
    "UPI Transaction Reference Number (if advance already paid)": "UPI ट्रांज़ैक्शन रेफरेंस नंबर (यदि एडवांस भर चुके हैं)",
    "Upload Payment Screenshot (optional)": "भुगतान स्क्रीनशॉट अपलोड करें (वैकल्पिक)",
    "Need accommodation & fooding assistance (separate charges)": "आवास व भोजन सहायता चाहिए (अलग शुल्क)",
    "Additional Requirements": "अतिरिक्त आवश्यकताएँ",
    "Submit Booking Request": "बुकिंग अनुरोध जमा करें",
    "Submitting...": "जमा हो रहा है...",
    "Your Selection": "आपका चयन",
    "Total Ritual Price": "कुल अनुष्ठान मूल्य",
    "40% Advance — pay now": "40% एडवांस — अभी दें",
    "60% Balance — on arrival": "60% शेष — आगमन पर",
    "No payment is taken on this website. Pay the advance via the UPI QR or bank transfer in the Payment section and enter your transaction reference above.":
        "इस वेबसाइट पर कोई भुगतान नहीं लिया जाता। भुगतान अनुभाग में UPI QR या बैंक ट्रांसफर से एडवांस दें और ऊपर अपना ट्रांज़ैक्शन रेफरेंस दर्ज करें।",
    "UPI QR Code": "UPI QR कोड",
    "Bank Transfer (NEFT / IMPS)": "बैंक ट्रांसफर (NEFT / IMPS)",
    "Will pay after discussion on WhatsApp": "व्हाट्सएप पर चर्चा के बाद भुगतान करूँगा",
    "Your full name": "आपका पूरा नाम",
    "e.g. 4": "जैसे 4",
    "e.g. 4321 5678 9012": "जैसे 4321 5678 9012",
    "Gotra, ancestor names, or any special requests (optional)": "गोत्र, पूर्वजों के नाम या कोई विशेष अनुरोध (वैकल्पिक)",
    "Booking Request Received": "बुकिंग अनुरोध प्राप्त हुआ",
    "Reference": "संदर्भ",
    "Payment proof attached": "भुगतान प्रमाण संलग्न",
    "Booking confirmation is subject to payment verification by Dharm Sarovar Private Limited. If you have not paid yet, use the UPI QR or bank details in the Payment section.":
        "बुकिंग की पुष्टि धर्म सरोवर प्राइवेट लिमिटेड द्वारा भुगतान सत्यापन के अधीन है। यदि आपने अभी भुगतान नहीं किया है, तो ऊपर भुगतान अनुभाग में UPI QR या बैंक विवरण का उपयोग करें।",
    "Confirm on WhatsApp": "व्हाट्सएप पर पुष्टि करें",
    "New Booking": "नई बुकिंग",
    "Dharm Sarovar Private Limited — authentic Pinddaan, Shradh & Tarpan rituals by traditional Gayawal Pandas at Gaya & Bodh Gaya, Bihar.":
        "धर्म सरोवर प्राइवेट लिमिटेड — गया और बोधगया, बिहार में परंपरागत गयावाल पांडों द्वारा प्रामाणिक पिंडदान, श्राद्ध एवं तर्पण अनुष्ठान।",
    "Contact": "संपर्क",
    "Bank Details": "बैंक विवरण",
    "Admin": "एडमिन",
    "Chapter 05 — Our Story": "अध्याय ०५ — हमारी कथा",
    "About Dharm Sarovar": "धर्म सरोवर परिचय",
    "Dharm Sarovar Private Limited was founded in Bodh Gaya with one purpose — to help families perform the final duties towards their ancestors with complete authenticity, dignity and peace of mind.":
        "धर्म सरोवर प्राइवेट लिमिटेड की स्थापना बोधगया में एक ही उद्देश्य से हुई — परिवारों को अपने पूर्वजों के प्रति अंतिम कर्तव्य पूर्ण प्रामाणिकता, सम्मान और मानसिक शांति के साथ निभाने में सहायता करना।",
    "Gaya is the holiest kshetra for Pitru karya — the land of Lord Vishnu's footprint at Vishnupad Temple, the sacred Falgu river, and the immortal Akshayavat. We work only with hereditary Gayawal Pandas who have performed these rituals for generations, exactly as prescribed in the scriptures.":
        "गया पितृ कार्य हेतु सर्वाधिक पवित्र क्षेत्र है — विष्णुपद मंदिर में भगवान विष्णु के चरणचिह्न की भूमि, पवित्र फल्गु नदी और अमर अक्षयवट। हम केवल उन वंशानुगत गयावाल पांडों के साथ कार्य करते हैं जो पीढ़ियों से शास्त्रानुसार ये अनुष्ठान करते आए हैं।",
    "From a single-day Pinddaan to the complete 17-day Sapindi Karan, we keep every price transparent — 40% advance, 60% on arrival — and assist your family with stay, food and travel so you can focus on the ritual, not the logistics.":
        "एक-दिवसीय पिंडदान से लेकर संपूर्ण 17-दिवसीय सपिंडीकरण तक — हम प्रत्येक मूल्य पारदर्शी रखते हैं (40% एडवांस, 60% आगमन पर) और आपके परिवार की आवास, भोजन व यात्रा में सहायता करते हैं, ताकि आप केवल अनुष्ठान पर ध्यान दें।",
    "Sacred Vedis": "पवित्र वेदियाँ",
    "Request Accommodation Assistance": "आवास सहायता हेतु अनुरोध करें",
    "Tell us your stay & food requirements and our team will contact you with options and charges.":
        "अपनी आवास व भोजन आवश्यकताएँ बताएं, हमारी टीम विकल्पों और शुल्क के साथ आपसे संपर्क करेगी।",
    "Full Name *": "पूरा नाम *",
    "Phone / WhatsApp *": "फोन / व्हाट्सएप *",
    "Check-in Date": "चेक-इन तिथि",
    "Check-out Date": "चेक-आउट तिथि",
    "Guests": "अतिथि संख्या",
    "Stay Preference": "आवास प्राथमिकता",
    "Any preference": "कोई भी विकल्प",
    "Hotel (AC)": "होटल (एसी)",
    "Hotel (Non-AC)": "होटल (नॉन-एसी)",
    "Dharamshala": "धर्मशाला",
    "Requirements (food, pickup, budget...)": "आवश्यकताएँ (भोजन, पिक-अप, बजट...)",
    "Submit Request": "अनुरोध जमा करें",
    "Stay Request Received": "आवास अनुरोध प्राप्त हुआ",
    "Our team will contact you on WhatsApp with stay options & charges.":
        "हमारी टीम आवास विकल्पों और शुल्क के साथ व्हाट्सएप पर संपर्क करेगी।",
    "Chat on WhatsApp instead": "या व्हाट्सएप पर सीधे बात करें",
    "New Request": "नया अनुरोध",
    "Pitrupaksha 2026: 26 Sep – 10 Oct": "पितृपक्ष 2026: 26 सितंबर – 10 अक्टूबर",
    "Sarva Pitru Amavasya on 10 Oct — reserve your Shradh date early, limited panda availability":
        "सर्व पितृ अमावस्या 10 अक्टूबर — अपनी श्राद्ध तिथि जल्दी आरक्षित करें, सीमित पांडा उपलब्धता",
    "Reserve Your Date": "तिथि आरक्षित करें",
    "Pitrupaksha 2026 — Shradh Tithi Guide": "पितृपक्ष 2026 — श्राद्ध तिथि मार्गदर्शिका",
    "Select the exact tithi of your ancestor — the booking date fills automatically.":
        "अपने पूर्वज की सही तिथि चुनें — बुकिंग तिथि अपने आप भर जाएगी।",
    "Sat": "शनि", "Sun": "रवि", "Mon": "सोम", "Tue": "मंगल", "Wed": "बुध", "Thu": "गुरु", "Fri": "शुक्र",
    "Purnima Shraddha": "पूर्णिमा श्राद्ध",
    "Pratipada Shraddha": "प्रतिपदा श्राद्ध",
    "Dwitiya Shraddha": "द्वितीया श्राद्ध",
    "Tritiya Shraddha": "तृतीया श्राद्ध",
    "Chaturthi Shraddha": "चतुर्थी श्राद्ध",
    "Panchami Shraddha": "पंचमी श्राद्ध",
    "Shashthi Shraddha": "षष्ठी श्राद्ध",
    "Saptami Shraddha": "सप्तमी श्राद्ध",
    "Ashtami Shraddha": "अष्टमी श्राद्ध",
    "Navami Shraddha": "नवमी श्राद्ध",
    "Dashami Shraddha": "दशमी श्राद्ध",
    "Ekadashi Shraddha": "एकादशी श्राद्ध",
    "Dwadashi Shraddha": "द्वादशी श्राद्ध",
    "Chaturdashi Shraddha": "चतुर्दशी श्राद्ध",
    "Sarva Pitru Amavasya": "सर्व पितृ अमावस्या",
    "Maha Bharani": "महा भरणी",
    "Magha Shraddha": "मघा श्राद्ध",
    "Mahalaya": "महालय",
    "starts in": "शुरू होने में",
    "Reviews": "समीक्षाएँ",
    "Blog": "लेख",
    "Voices of Families": "परिवारों की आवाज़",
    "What Families Say": "परिवार क्या कहते हैं",
    "Chapter 06 — Gyaan & Guidance": "अध्याय ०६ — ज्ञान एवं मार्गदर्शन",
    "Ritual Guidance & Blog": "अनुष्ठान मार्गदर्शन एवं लेख",
    "From a single-day Pinddaan to the complete 17-day Sapindi Karan, we keep every price transparent — 40% advance, 60% one day before arrival — and assist your family with stay, food and travel so you can focus on the ritual, not the logistics.":
        "एक-दिवसीय पिंडदान से लेकर संपूर्ण 17-दिवसीय सपिंडीकरण तक — हम प्रत्येक मूल्य पारदर्शी रखते हैं (40% एडवांस, 60% आगमन से एक दिन पहले) और आपके परिवार की आवास, भोजन व यात्रा में सहायता करते हैं, ताकि आप केवल अनुष्ठान पर ध्यान दें।",
    "60% Before Arrival": "60% आगमन से पहले",
    "60% Balance — 1 day before arrival": "60% शेष — आगमन से 1 दिन पहले",
    "Pay the remaining 60% one day before arrival for a smooth process.": "सुगम प्रक्रिया हेतु शेष 60% आगमन से एक दिन पहले दें।",
    "Pay via UPI QR": "UPI QR से भुगतान करें",
    "After QR payment, submit your booking and share the payment details on WhatsApp.": "QR भुगतान के बाद अपनी बुकिंग जमा करें और भुगतान विवरण व्हाट्सएप पर साझा करें।",
    "Recommended": "अनुशंसित",
    "Cancellation & Refund Policy": "रद्दीकरण एवं धनवापसी नीति",
    "Full advance refund for cancellations made at least 72 hours before the ritual date; 50% refund within 72 hours. Refunds are processed to the original payment method within 5–7 working days.":
        "अनुष्ठान तिथि से कम से कम 72 घंटे पहले रद्द करने पर पूर्ण एडवांस वापसी; 72 घंटे के भीतर 50% वापसी। धनवापसी मूल भुगतान माध्यम में 5–7 कार्यदिवसों में संसाधित होती है।",
    "Accommodation Assistance": "आवास सहायता",
    "No stay assistance needed": "आवास सहायता आवश्यक नहीं",
    "AC Premium — ₹5,000 / day": "एसी प्रीमियम — ₹5,000 / दिन",
    "Non-AC Budget — ₹3,000 / day": "नॉन-एसी बजट — ₹3,000 / दिन",
    "Stay Assistance": "आवास सहायता",
    "/ day": "/ दिन",
    "Read Article": "लेख पढ़ें",
    "Chapter 03 — Secure Payment": "अध्याय ०३ — सुरक्षित भुगतान",
    "Pay 40% Advance Online — Instant Confirmation": "40% एडवांस ऑनलाइन दें — तुरंत पुष्टि",
    "Book your ritual and pay the advance securely via Razorpay — UPI, cards and netbanking accepted. Booking is confirmed instantly after payment; no screenshots or reference numbers needed.":
        "अपना अनुष्ठान बुक करें और Razorpay से सुरक्षित एडवांस दें — UPI, कार्ड, नेटबैंकिंग स्वीकार्य। भुगतान के बाद बुकिंग तुरंत कन्फर्म; स्क्रीनशॉट या रेफरेंस नंबर की आवश्यकता नहीं।",
    "Select your ritual package and submit the booking form.": "अपना अनुष्ठान पैकेज चुनें और बुकिंग फॉर्म जमा करें।",
    "Pay the 40% advance securely online via Razorpay.": "Razorpay से 40% एडवांस सुरक्षित ऑनलाइन दें।",
    "Booking is confirmed instantly — payment ID is saved to your booking.": "बुकिंग तुरंत कन्फर्म — भुगतान ID आपकी बुकिंग में सहेजी जाती है।",
    "Pay the remaining 60% on arrival in Gaya.": "शेष 60% गया आगमन पर दें।",
    "How Payment Works": "भुगतान कैसे काम करता है",
    "Secure Payment by Razorpay": "Razorpay द्वारा सुरक्षित भुगतान",
    "Your advance goes directly to Dharm Sarovar Private Limited's verified account.": "आपका एडवांस सीधे धर्म सरोवर प्राइवेट लिमिटेड के सत्यापित खाते में जाता है।",
    "Book & Pay Advance": "बुक करें और एडवांस दें",
    "Payments processed securely by Razorpay. Booking is confirmed instantly after successful payment.":
        "भुगतान Razorpay द्वारा सुरक्षित रूप से संसाधित होता है। सफल भुगतान के बाद बुकिंग तुरंत कन्फर्म होती है।",
    "Need help with payment?": "भुगतान में सहायता चाहिए?",
    "Pay Advance Securely": "एडवांस सुरक्षित भुगतान करें",
    "Advance Paid — Booking Confirmed": "एडवांस प्राप्त — बुकिंग कन्फर्म",
    "Payment ID": "भुगतान ID",
    "Pay the 40% advance securely online after submitting — UPI, cards & netbanking via Razorpay.":
        "जमा करने के बाद 40% एडवांस ऑनलाइन सुरक्षित दें — Razorpay से UPI, कार्ड व नेटबैंकिंग।",
    "Processing...": "प्रोसेस हो रहा है...",
    "Pitrupaksha is live — book your tithi now": "पितृपक्ष चल रहा है — अभी अपनी तिथि बुक करें",
    "Home": "होम",
    "Accommodation": "आवास",
    "About": "परिचय",
    "Also visit": "यह भी देखें",
    "Bodh Gaya, Bihar 823004, India": "बोधगया, बिहार 823004, भारत",
    "60% Balance": "60% शेष",
    "Choose image file (max 3MB)": "छवि फ़ाइल चुनें (अधिकतम 3MB)",
    "1 Day Rituals": "1 दिवसीय अनुष्ठान",
    "1 Day Ritual Packages": "1 दिवसीय अनुष्ठान पैकेज",
    "Single-day rituals at the sacred vedis of Gaya — complete Pinddaan & Shradh along with special rituals like Tripindi Shradh, Narayan Bali, Nag Bali and Pitru Dosha Nivaran.":
        "गया की पवित्र वेदियों पर एक-दिवसीय अनुष्ठान — संपूर्ण पिंडदान एवं श्राद्ध तथा त्रिपिंडी श्राद्ध, नारायण बलि, नाग बलि और पितृ दोष निवारण जैसे विशेष अनुष्ठान।",
    "Multi-Day Rituals": "बहु-दिवसीय अनुष्ठान",
    "Complete Multi-Day Pinddaan & Shradh Packages": "संपूर्ण बहु-दिवसीय पिंडदान एवं श्राद्ध पैकेज",
    "Extended 3, 5, 7 and 17-day ritual programmes at the sacred vedis of Gaya, performed by traditional Gayawal Pandas.":
        "परंपरागत गयावाल पांडों द्वारा गया की पवित्र वेदियों पर 3, 5, 7 और 17-दिवसीय विस्तारित अनुष्ठान कार्यक्रम।",
};

export const tr = (lang, s) => (lang === "hi" && HI[s]) || s;
